// extracted by mini-css-extract-plugin
export default {"footer_section":"footer_footer_section__-1Yrv","logo":"footer_logo__WLyGd","row_sec":"footer_row_sec__EImOc","bottom_footer":"footer_bottom_footer__XHyMn"};